import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';
import ProcessWarningOverlay from '../ProcessWarningOverlay/ProcessWarningOverlay';
import EDOverlay from '../../../../BaseComponents/Overlay/EDOverlay';
import EDButton from '../../../../BaseComponents/Buttons/Button/EDButton';
import EDTooltip from '../../../../BaseComponents/Tooltip/EDTooltip';

export interface IProcessButton {
  Kod: string;
  Benamning: string;
  Warning?: string;
}

interface IProps {
  content: IProcessButton[];
  selected?: IProcessButton;
  onSelect: (select: IProcessButton) => void;
  buttonSize: 'small' | 'medium' | 'large';
  fullLabels?: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  container: {},
  processButtons: {
    transform: 'skew(-30deg)',
  },
  processButtons_small: {
    marginLeft: theme.spacing(4),
  },
  processButtons_medium: {
    display: 'flex',
    flex: '1 1 0%',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    justifyContent: 'flex-end',
  },
  processButtons_large: {
    display: 'flex',
    flex: '1 1 0%',
    alignItems: 'center',
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(12),
    justifyContent: 'center',
  },
  processButtonLabel: {
    transform: 'skew(30deg)',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    verticalAlign: 'middle',
    fontWeight: 400,
  },
  processButtonSubLabel: {
    textTransform: 'none',
  },
  processButtonOverlay: {
    transform: 'skew(30deg)',
    bottom: '-6px',
    right: '2px',
  },
});

/**
 * Baskomponent för en processknapprad i processvyn
 */
export const ProcessButtons: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { content, classes } = props;

  return (
    <div
      className={classNames(
        classes.container,
        classes['processButtons_' + props.buttonSize],
        classes.processButtons
      )}
    >
      {content.map(sender => (
        <EDOverlay
          key={sender.Kod + sender.Benamning}
          overlay={sender.Warning && <ProcessWarningOverlay />}
          classes={{ overlay: classes.processButtonOverlay }}
        >
          <EDTooltip title={sender.Warning}>
            <EDButton
              onClick={() => props.onSelect(sender)}
              label={
                <div className={classNames(classes.processButtonLabel)}>
                  {sender.Kod}
                  {props.fullLabels && (
                    <React.Fragment>
                      <br />
                      <span className={classes.processButtonSubLabel}>
                        {sender.Benamning}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              }
              padding={1}
              size={props.buttonSize}
            />
          </EDTooltip>
        </EDOverlay>
      ))}
    </div>
  );
};

export default withStyles(ProcessButtons, styles);
